import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackGaPageView } from "@/analytics/googleAnalytics";
import { shouldTrackAnalytics } from "@/analytics/tracking";

/**
 * SPA route changes: index.html gtag config already records the first page view.
 */
export default function GoogleAnalytics() {
  const { pathname, search } = useLocation();
  const skipNextPageView = useRef(true);

  useEffect(() => {
    if (!shouldTrackAnalytics(pathname)) return;

    if (skipNextPageView.current) {
      skipNextPageView.current = false;
      return;
    }

    trackGaPageView(pathname, search);
  }, [pathname, search]);

  return null;
}
